import { getFilesFromFolders } from "@/lib/folder";
import { useQuery } from "@tanstack/react-query";
import { useIsApiReady } from "../hooks/use-api-ready";
import { groupFolderControllerGetAll } from "../lib/gen-api";
import { queryKeys } from "../lib/query-keys";

type ArtifactListAccess = "owner" | "write" | "read";

export const useGroupFoldersData = ({
  groupUuid,
  access,
}: {
  groupUuid?: string | null;
  access?: ArtifactListAccess;
}) => {
  const {
    data: folders,
    isPending,
    error,
  } = useQuery({
    enabled: useIsApiReady() && !!groupUuid,
    queryKey: queryKeys.groupFolders({
      groupUuid: groupUuid!,
      access,
    }),
    queryFn: () => {
      return groupFolderControllerGetAll({
        path: {
          groupUuid: groupUuid!,
        },
        query: access ? { filter: { access } } : undefined,
      }).then((res) => res.data?.data ?? []);
    },
  });

  const files = getFilesFromFolders(folders ?? []);

  return { folders: folders ?? [], isLoading: isPending, error, files };
};
